import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { transition } from "../../utils/transition";
import { disabledState } from "../../theme/disabledState";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    gap: `${theme.spacings.xs} ${theme.spacings.m}`,
  },
  variants: {
    orientation: {
      horizontal: {
        flexWrap: "wrap",
      },
      vertical: {},
    },
  },
});

export const radioButtonStyle = recipe({
  base: {
    transition: transition("opacity"),
    gap: theme.spacings.xs,
    paddingLeft: theme.spacings.xxs2,
  },
  variants: {
    checked: {
      true: {},
      false: {},
    },
    disabled: {
      true: {
        ...disabledState,
      },
    },
    error: {
      true: {},
    },
    success: {
      true: {},
    },
    highlight: {
      true: {},
    },
  },
});

export const radioCircleStyle = recipe({
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    flexGrow: 0,
    flexShrink: 0,
    borderRadius: "50%",
    overflow: "hidden",
    transition: transition(
      "background-color",
      "color",
      "outline",
      "border-color",
    ),
    backgroundColor: theme.colors.background,
    border: `1px solid var(--border, ${theme.colors.defaultBorder})`,
    color: theme.colors.onPrimary,
    selectors: {
      '&:not([aria-disabled="true"])': {
        cursor: "pointer",
      },
      '&:not([aria-disabled="true"]):hover': {
        backgroundColor: `var(--background__hover, ${theme.colors.primary})`,
        borderColor: `var(--border__hover, ${theme.colors.primaryHover})`,
      },
    },
    height: rem(20),
    width: rem(20),
  },
  variants: {
    checked: {
      true: {
        borderColor: `var(--border__checked, ${theme.colors.primary})`,
        backgroundColor: `var(--background__checked, ${theme.colors.primary})`,
        selectors: {
          '&:not([aria-disabled="true"]):hover': {
            backgroundColor: `var(--background__checked__hover, ${theme.colors.primaryHover})`,
            borderColor: `var(--border__checked__hover, ${theme.colors.primaryHover})`,
          },
        },
      },
    },
    disabled: {
      true: {
        ...disabledState,
      },
    },
    error: {
      true: {
        vars: {
          "--border": theme.colors.error,
          "--background__hover": theme.colors.error,
          "--border__hover": theme.colors.error,
          "--background__checked": theme.colors.error,
          "--border__checked": theme.colors.error,
          "--background__checked__hover": theme.colors.error,
          "--border__checked__hover": theme.colors.error,
        },
      },
    },
    success: {
      true: {},
    },
    highlight: {
      true: {
        vars: {
          "--border": theme.colors.warning,
          "--background__hover": theme.colors.warning,
          "--border__hover": theme.colors.warning,
          "--background__checked": theme.colors.warning,
          "--border__checked": theme.colors.warning,
          "--background__checked__hover": theme.colors.warning,
          "--border__checked__hover": theme.colors.warning,
        },
      },
    },
  },
});

export const radioInputStyle = style({
  opacity: 0,
  position: "absolute",
  width: "100%",
  height: "100%",
  margin: 0,
  cursor: "pointer",
  selectors: {
    "&:disabled": {
      cursor: "not-allowed",
    },
  },
});

export const radioInnerCircleStyle = recipe({
  base: {
    borderRadius: "50%",
    backgroundColor: theme.colors.onPrimary,
    transition: transition("transform", "opacity"),
    position: "absolute",
    transform: "scale(0)",
    opacity: 0,
    width: rem(10),
    height: rem(10),
  },
  variants: {
    checked: {
      true: {
        transform: "scale(1)",
        opacity: 1,
      },
      false: {
        transform: "scale(0)",
        opacity: 0,
      },
    },
  },
});

export const labelStyle = recipe({
  base: {
    paddingTop: theme.spacings.xxs2,
    cursor: "pointer",
    userSelect: "none",
  },
  variants: {
    disabled: {
      true: {
        ...disabledState,
        cursor: "not-allowed",
      },
    },
  },
});

export const radioSuccessStyle = style({
  marginTop: rem(2),
});
